var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"customs-usd-rate-warning"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"customs-usd-rate-warning-chip",attrs:{"uk-tooltip":"title: 달러 환산 금액은 관세청고시 \"주간(수입)환율\"에 따라 변동됩니다.; pos: top-left; cls: uk-active customs-usd-rate-warning-tooltip"}},[_c('i',{staticClass:"material-icons"},[_vm._v("warning")]),_vm._v("\n        환율변동주의\n    ")])
}]

export { render, staticRenderFns }